import AbacusClientUtils from '@homeaway/abacus-client-utils';

export const isExperimentBucketed = (experimentName) => {
    const experimentBucket =
        AbacusClientUtils.evaluateExperimentAndLog(experimentName);
    return experimentBucket?.value === 1;
};
